import React from "react";
import Banner from "./Banner";
import RoomSuits from "./RoomSuits";
import About from "./AboutUs";
import Expirence from "./Expirence";
import Gallary from "./Gallary";
import Footer from "./Footer";
import StickyMenu from "./StickyMenu";
import { Element } from "react-scroll"; 

function Home() {
  return (
    <div>
      
      <StickyMenu />
      
      <Banner/>
      <RoomSuits />
      <About />

      <Element name="gallery-section">
        <Gallary />
      </Element>
      
      <Expirence />
      <Footer />

      
    </div>
  );
}

export default Home;
